/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetEnergyConsumptionPathParameters } from 'api/actions/get-energy-consumption/get-energy-consumption-path-parameters';
import { GetEnergyConsumptionResponse } from 'api/actions/get-energy-consumption/get-energy-consumption-response';

type GetEnergyConsumptionQueryParameters = Record<string, any>;

/**
 * The path of the GetEnergyConsumption action.
 */
export const getEnergyConsumptionActionPath = new SweetPath<keyof GetEnergyConsumptionPathParameters>(
  '/tuya-device/energy-consumption/{deviceId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetEnergyConsumption actions.
 */
export default function createGetEnergyConsumptionAction(axios: AxiosInstance) {
  return function getEnergyConsumptionAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetEnergyConsumptionPathParameters;
    query?: GetEnergyConsumptionQueryParameters;
  }) {
    const path = getEnergyConsumptionActionPath.insert(parameters);

    return axios.get<GetEnergyConsumptionResponse, GetEnergyConsumptionResponse>(path, { params: query, headers });
  };
}
